




































import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';

export default {
  name: 'IconEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
    bufferType: {
      type: String,
      default: 'element',
    },
    label: {
      type: String,
    },
    singleLine: {
      type: Boolean,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: props.bufferType,
    });

    return {
      buffer,
      save,
    };
  },
  data() {
    return {
      sizes: ['small', 'medium', 'large', 'xl'],
    };
  },
};
